export default __webpack_public_path__ + "static/Royal-Pillow 2-59b2a0b6af963ce2b989c05edda1bb6c.png";